// Pathify
import { make } from 'vuex-pathify'
import { importChunk } from '@/util/helpers'

const _ = require('lodash')

const endpoint = 'https://de06el5wp2.execute-api.us-east-2.amazonaws.com'
const setIsBusy = 'setIsBusy'

const state = {
  displayAsSingular: 'Prompt',
  displayAsPlural: 'Prompts',
  prompts: {
    all: [],
    data: [],
    originalData: [],
    toImport: [],
    isBusy: false,
    selected: [],
    selectedItem: { id: '', description: '' },
    empty: {
      id: null,
      sort_order: null,
      prompt_id: null,
      client_id: null,
      plan_id: null,
      phase_id: null,
      assembly_id: null,
      pv_id: null,
      description: null,
      value: 0,
      variable: null,
      operator: '',
      prompt_group: null,
    },
    headers: {
      /* New Field */
      headerSortOrder: {
        text: 'Sort Order',
        align: 'start',
        value: 'sort_order',
        sortable: false,
        filterable: true,
        width: '1%',
        class: 'primary--text font-weight-bold text-no-wrap',
      },
      headerPrompt: {
        text: 'Prompt',
        align: 'start',
        value: 'description',
        sortable: false,
        filterable: true,
        width: '1%',
        class: 'primary--text font-weight-bold text-no-wrap',
      },
      headerValue: {
        text: 'Value',
        align: 'end',
        value: 'value',
        sortable: false,
        filterable: true,
        width: '1%',
        class: 'primary--text font-weight-bold text-no-wrap',
      },
      headerVariable: {
        text: 'Variable',
        align: 'start',
        value: 'variable',
        sortable: false,
        filterable: true,
        width: '1%',
        class: 'primary--text font-weight-bold text-no-wrap',
      },
    },
    tabbedColumns: {
      id_header: 'Prompt Variable Name',
      description_header: 'Prompt Description',
      sortOrder_header: 'Prompt Sort Order',
    },
  },
}

const mutations = {
  ...make.mutations(state),

  setIsBusy: (state, isBusy) => {
    state.prompts.isBusy = isBusy
  },

  push2All: (state, dataFromDB) => {
    state.prompts.all = []

    // Get a copy of the original data, not a pointer to it
    for (const currentData of dataFromDB) {
      state.prompts.all.push({ ...currentData })
    }

    state.prompts.isBusy = false
  },

  push2Data: (state, dataFromDB) => {
    state.prompts.data = []
    state.prompts.data = dataFromDB

    // Get a copy of the original data, not a pointer to it
    state.prompts.originalData = []
    for (const currentData of dataFromDB) {
      state.prompts.originalData.push({ ...currentData })
    }

    state.prompts.selected = []

    state.prompts.isBusy = false
  },

  push2Import: (state, data2Import) => {
    state.prompts.toImport = []
    state.prompts.toImport = data2Import
    state.prompts.isBusy = false
  },

  successfulUpdate: (state) => {},

  successfulDelete: (state) => {},

  importCompleted: (state) => {},
}

const actions = {
  ...make.actions(state),

  init: async () => {
    //
  },

  setEmpty: ({ dispatch }) => {
    state.prompts.selected = []
    state.prompts.selectedItem = { id: '', description: '' }
    state.prompts.data = []
  },

  setSelected: ({ dispatch }, payload) => {
    if (payload) {
      state.prompts.selected = []
      state.prompts.selectedItem = { ...payload }
    } else {
      state.prompts.selectedItem = { id: '', description: '' }
    }
  },

  retrieveAll: ({ commit, dispatch, rootState }) => {
    if (rootState.customer.customers.selectedItem.client_id.length > 0) {
      const thisAction = 'retrieveAllPrompts'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'get',
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          commit('push2All', jsonResponse.data)
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  retrieve: ({ commit, dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload &&
        {}.hasOwnProperty.call(payload, 'client_id') &&
        {}.hasOwnProperty.call(payload, 'plan_id') &&
        {}.hasOwnProperty.call(payload, 'phase_id') &&
        {}.hasOwnProperty.call(payload, 'assembly_id') &&
        {}.hasOwnProperty.call(payload, 'pv_id')) {
        if (payload.client_id && payload.plan_id && payload.phase_id && payload.assembly_id && payload.pv_id) {
          const thisAction = 'retrievePrompt'
          commit(setIsBusy, true)

          const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
          const url = `${actionEndPoint}/${payload.client_id}/${payload.plan_id}/${payload.phase_id}/${payload.assembly_id}/${payload.pv_id}`

          const options = {
            method: 'get',
          }

          fetch(url, options)
            .then(response => {
              const statusMessage = `${response.status}: "${response.statusText}"`

              if (!response.ok) {
                throw Error(statusMessage)
              }

              return response.json()
            })
            .then(jsonResponse => {
              if (_.isEmpty(jsonResponse.error)) {
                commit('push2Data', jsonResponse.data)
              } else {
                commit(setIsBusy, false)
              }

              resolve(jsonResponse)
            })
            .catch(error => {
              console.error(`${thisAction} failed with url: ${url}`)
              commit(setIsBusy, false)
              dispatch('error/setError', { name: thisAction, details: error }, { root: true })
              reject(error)
            })
        } else {
          resolve(null)
        }
      } else {
        resolve(null)
      }
    })
  },

  retrieveByPromptGroupId: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'retrievePromptGroup'
    commit(setIsBusy, true)

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}/${payload.pv_id}`

    const options = {
      method: 'get',
    }

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        commit('push2Data', jsonResponse.data)
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  update: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'updatePrompts'
    commit(setIsBusy, true)

    payload.prompt_value = payload.value

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}`

    const options = {
      method: 'post',
      body: JSON.stringify(payload),
    }

    let toastColor = 'success'
    let toastMessage = 'updated successfully'

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          // Update selected
          if (state.prompts.selectedItem && {}.hasOwnProperty.call(state.prompts.selectedItem, 'id')) {
            if (payload.prompt_id === state.prompts.selectedItem.id) {
              dispatch('setSelected', payload)
            }
          }

          if ({}.hasOwnProperty.call(payload, 'assembly_id')) {
            dispatch('retrieve', payload)
          } else {
            dispatch('retrieveByPromptGroupId', payload)
          }
        } else {
          toastColor = 'danger'
          toastMessage = 'was not updated successfully'
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
        }
      })
      .then(() => {
        console.info(`${state.displayAsSingular} Updated - '${payload.description}' ${toastMessage}, variant: ${toastColor}`)
        commit('successfulUpdate')
        /*
        dispatch('user/showToast',
          {
            title: `${state.displayAsSingular} Updated`,
            messages: [`'${payload.description}' ${toastMessage}`],
            variant: toastColor,
          },
          { root: true },
        )
         */
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  delete: ({ commit, dispatch, rootState }) => {
    if (state.prompts.selected.length > 0) {
      const thisAction = 'deletePrompts'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'post',
        body: JSON.stringify(state.prompts.selected),
      }

      let toastColor = 'success'
      let toastPrefix = ''
      let toastMessage = 'successfully removed'
      if (state.prompts.selected.length > 1) {
        toastPrefix = `${state.prompts.selected.length} ${state.displayAsPlural} were`
      } else {
        toastPrefix = `'${state.prompts.selected[0].description}'`
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          if (_.isEmpty(jsonResponse.error)) {
            // Remove deleted from selected
            if (state.prompts.selectedItem && {}.hasOwnProperty.call(state.prompts.selectedItem, 'id')) {
              for (const currentData of state.prompts.selected) {
                if (currentData.prompt_id === state.prompts.selectedItem.id) {
                  dispatch('setSelected', state.prompts.data[0])
                  break
                }
              }
            }

            commit('successfulDelete')
          } else {
            toastColor = 'danger'
            toastMessage = 'was not deleted successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            commit(setIsBusy, false)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
          }
        })
        .then(() => {
          console.info(`${state.displayAsSingular} Deleted - ${toastPrefix} ${toastMessage}, variant: ${toastColor}`)
          /*
          dispatch('user/showToast',
            {
              title: `${state.displayAsSingular} Deleted`,
              messages: [`'${payload.description}' ${toastMessage}`],
              variant: toastColor,
            },
            { root: true },
          )
          */
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  importAll: async ({ commit, dispatch, rootState, state }, payload) => {
    const thisAction = 'updatePrompts'

    if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.length > 0) {
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const emptyItem = { ...state.prompts.empty }
      dispatch('user/setStateAsUpdated', emptyItem, { root: true })

      // Get an even number of records in each chunk
      const numberOfChunks = Math.ceil(payload.length / 100)
      const maxSize = Math.ceil(payload.length / numberOfChunks)
      const chunks2Import = []
      let chunkSize = 0
      let possibleChunkSize = 0
      let totalAttempted = 0
      let items2Import = []
      let item2Import = {}

      // Loop through prompt groups and get a set of prompts by prompt group
      let pvPrompts = []
      const promptGroups = rootState.promptgroup.promptGroups.data

      for (const promptGroup of promptGroups) {
        pvPrompts = payload.filter(data => data.pv_id.toString() === promptGroup.pv_id.toString())
        possibleChunkSize = chunkSize + pvPrompts.length

        // if these prompts for this prompt group will push the chunk over size, then go ahead and send the current chunk
        if (possibleChunkSize >= maxSize) {
          chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))

          totalAttempted += chunkSize
          chunkSize = 0
          items2Import = []
        }

        // Add all of the prompts for this prompt group to the chunk
        for (const currentItem of pvPrompts) {
          // Ensure we have all required data and the proper selected client
          item2Import = { ...emptyItem }

          item2Import.pv_id = currentItem.pv_id
          item2Import.variable = currentItem.id
          item2Import.description = currentItem.description
          item2Import.sort_order = currentItem.sort_order

          items2Import.push(item2Import)
          ++chunkSize
        }
      }

      if (chunkSize > 0) {
        chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))
        totalAttempted += chunkSize
      }

      let toastColor = 'success'
      let toastMessage = 'imported successfully'

      if (chunks2Import.length > 0) {
        // Once all promises are resolved we have a successful import, or display rejected error
        Promise.all(chunks2Import)
          .then(responses => {
            dispatch('importData/setImportCount', { sheetName: state.displayAsPlural, importCount: totalAttempted }, { root: true })
            dispatch('importData/setSelectedIsComplete', state.displayAsPlural, { root: true })
            commit('importCompleted')

            toastColor = 'success'
            toastMessage = 'imported successfully'

            for (const thisResponse of responses) {
              if (_.isEmpty(thisResponse.error)) {
                console.info(`${thisResponse.details} { ${toastMessage}, variant: ${toastColor} }`)
              } else {
                toastColor = 'danger'
                toastMessage = 'were not imported successfully'
                console.error(`${thisAction} failed: items ${toastMessage}, variant: ${toastColor}`, responses)
                commit(setIsBusy, false)
                dispatch('importData/setIsBusy', false, { root: true })
                dispatch('error/setError', thisResponse, { root: true })
                break
              }
            }
          })
          .catch(error => {
            console.error(`${thisAction} failed for ${state.displayAsSingular}`)
            commit(setIsBusy, false)
            dispatch('importData/setIsBusy', false, { root: true })
            dispatch('error/setError', { name: thisAction, details: error }, { root: true })
          })
      } else {
        console.error(`${thisAction} failed for ${state.displayAsSingular} due to empty chunks`)
        commit(setIsBusy, false)
        dispatch('importData/setIsBusy', false, { root: true })

        toastColor = 'warning'

        dispatch('user/showToast',
          {
            title: `Import ${state.displayAsPlural}`,
            messages: [`No ${state.displayAsPlural.toLowerCase()} were imported`],
            variant: toastColor,
          },
          { root: true },
        )
      }
    } // client_id & payload length > 0
  },

  push2Import: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = `Push ${state.displayAsPlural} to Import`

    if (payload && {}.hasOwnProperty.call(payload, 'sheetData')) {
      if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.sheetData.length > 0) {
        commit(setIsBusy, true)

        const emptyItem = { id: null, prompt_id: null, pv_id: null, description: null, value: 0, variable: null, sort_order: null }
        const items2Import = []
        let item2Import = {}

        for (const currentItem of payload.sheetData) {
          item2Import = { ...emptyItem }

          item2Import.id = currentItem[state.prompts.tabbedColumns.id_header]
          item2Import.pv_id = currentItem[rootState.promptgroup.promptGroups.tabbedColumns.id_header]
          item2Import.description = currentItem[state.prompts.tabbedColumns.description_header]
          item2Import.variable = currentItem[state.prompts.tabbedColumns.id_header]
          item2Import.sort_order = currentItem[state.prompts.tabbedColumns.sortOrder_header]

          items2Import.push(item2Import)
        }

        dispatch('importData/setRows', { sheetName: state.displayAsPlural, sheetRows: items2Import.length }, { root: true })
        commit('push2Import', items2Import)
      }
    }
  },

  executeImport: ({ dispatch }) => {
    dispatch('importAll', state.prompts.toImport)
  },
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
